// removed by extract-text-webpack-plugin
module.exports = {"userWrap":"User__userWrap___qIO_X","avatar":"User__avatar___xHipb","info":"User__info___2nz1B","id":"User__id___2aJaP"};


//////////////////
// WEBPACK FOOTER
// ./modules/User.css
// module id = 646
// module chunks = 0